module.exports = __webpack_public_path__ + "img/output-of-training-model-02.919cc1cc.png";